import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.1_@parcel+watcher@2.5.1_@types+node@20.17.26_db0@0.3.1_encoding@0.1.13_eslint_8fdcce56b77844757ad883897639172d/node_modules/nuxt/dist/pages/runtime/validate.js";
import page_45transition_45global from "/vercel/path0/middleware/pageTransition.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.1_@parcel+watcher@2.5.1_@types+node@20.17.26_db0@0.3.1_encoding@0.1.13_eslint_8fdcce56b77844757ad883897639172d/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  page_45transition_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}